import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

export default KeyboardArrowUpIcon;
